import React, { useEffect } from 'react';

function Captcha(props) {
  useEffect(() => {
    if (window.initAlicom4) {
      window.initAlicom4(
        props['captcha-config'].config,
        props['captcha-config'].handler
      );
    }
  }, []);

  return (
    <div className="captcha"></div>    
  );
}


export default Captcha;